var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UniFrame',{attrs:{"universalFrameStateGlobal":_vm.stateGlobal}},[_c('ToolView',{attrs:{"slot":"main-View"},slot:"main-View"}),_c('Login',{attrs:{"slot":"login-View"},slot:"login-View"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }